import * as React from 'react';
import { useState } from 'react';

// Utils
import { useTranslation } from 'react-i18next';
import { isNilOrEmpty } from '@src/shared/src/util/general';
// Constants
// Actions
// Models
// Interfaces
// Components
import HotelFacilitiesAll from './HotelFacilitiesAll';

// Styles
import '../styles/HotelRoomDetails.scss';

type Props = {
  roomDetails: string;
  amenities: string[];
};

const HotelRoomDetails: React.FC<Props> = ({ roomDetails, amenities }) => {
  const [showRoomDetails, setShowRoomDetails] = useState(false);
  const toggleShowRoom = () => setShowRoomDetails(!showRoomDetails);
  const { t } = useTranslation();

  if (isNilOrEmpty(roomDetails) && amenities.length === 0) {
    return null;
  }

  return (
    <div className="hotel-room-details">
      {showRoomDetails && roomDetails && <div className="hotel-room-details-list">{roomDetails}</div>}
      <div className="hotel-room-details-links">
        {amenities.length > 0 && (
          <>
            <HotelFacilitiesAll facilities={amenities} label={t('hotelFareGroup.amenities')} overlayTitle={t('hotelFareGroup.amenities')} />
            {roomDetails && <span>&nbsp;| &nbsp;</span>}
          </>
        )}
        {roomDetails && (
          <button className="tcp-link is--small" onClick={toggleShowRoom}>
            {t('hotelRoomDetails.button.roomDetails')}
            <i
              className={showRoomDetails ? 'icon-keyboard_arrow_up' : 'icon-keyboard_arrow_down'}
            />
          </button>
        )}
      </div>
    </div>
  );
};

export default HotelRoomDetails;
